import label from "@/lang/StaticLabels.js";

// PARAK Router  - ??????? ??? ------------------------------------------------
let routeItems = {
  path: "PPARAK",
  name: "PPARAK",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PPARAKDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PPARAKDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pparak,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/Dashboard"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "settingTransactions",
      name: "PPARAKSettingTransactions",
      meta: {
        label: label.page.settingTransactions,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pparak/base/transactionInfo/index.vue"),
    },
    {
      path: "commodityCategory",
      name: "PPARAKCommodityCategory",
      meta: {
        label: label.page.category,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pparak/base/commodityCategory/index.vue"),
    },
    {
      path: "commodityIntroduction",
      name: "PPARAKCommodityIntroduction",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/commodityIntroduction/list",
      children: [
        {
          path: "list",
          name: "PPARAKCommodityIntroductionList",
          component: () =>
            import(
              "@/views/modules/pparak/base/commodityIntroduction/index.vue"
            ),
          meta: {
            label: label.page.commodityIntroduction,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PPARAKCommodityIntroductionAdd",
          component: () =>
            import("@/views/modules/pparak/base/commodityIntroduction/add.vue"),
          meta: {
            label: label.page.addCommodity,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PPARAKCommodityIntroductionEdit",
          component: () =>
            import(
              "@/views/modules/pparak/base/commodityIntroduction/edit.vue"
            ),
          meta: {
            label: label.page.editCommodity,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "dealType",
      name: "PPARAKDealType",
      meta: {
        label: label.page.dealType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pparak/base/dealType/index.vue"),
    },
    {
      path: "cottage",
      name: "PPARAKCottage",
      meta: {
        label: label.page.cottage,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PPARAKCottageList",
          component: () =>
            import("@/views/modules/pparak/operation/cottage/index.vue"),
          meta: {
            label: label.page.cottage,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PPARAKCottageAdd",
          component: () =>
            import("@/views/modules/pparak/operation/cottage/add.vue"),
          meta: {
            label: label.page.addCottage,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PPARAKCottageEdit",
          component: () =>
            import("@/views/modules/pparak/operation/cottage/add.vue"),
          meta: {
            label: label.page.editCottage,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "purchase",
      name: "PPARAKPurchase",
      meta: {
        label: label.page.cottage,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PPARAKPurchaseList",
          component: () =>
            import("@/views/modules/pparak/operation/purchase/index.vue"),
          meta: {
            label: label.page.purchase,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PPARAKPurchaseAdd",
          component: () =>
            import("@/views/modules/pparak/operation/purchase/add.vue"),
          meta: {
            label: label.page.addPurchase,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PPARAKPurchaseEdit",
          component: () =>
            import("@/views/modules/pparak/operation/purchase/add.vue"),
          meta: {
            label: label.page.editPurchase,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "order",
      name: "PPARAKOrder",
      meta: {
        label: label.page.parakOrder,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PPARAKOrderList",
          component: () =>
            import("@/views/modules/pparak/operation/order/index.vue"),
          meta: {
            label: label.page.parakOrder,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PPARAKOrderAdd",
          component: () =>
            import("@/views/modules/pparak/operation/order/add.vue"),
          meta: {
            label: label.page.addOrder,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PPARAKOrderEdit",
          component: () =>
            import("@/views/modules/pparak/operation/order/add.vue"),
          meta: {
            label: label.page.editOrder,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "lading",
      name: "PPARAKLading",
      meta: {
        label: label.page.lading,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PPARAKLadingList",
          component: () =>
            import("@/views/modules/pparak/operation/lading/index.vue"),
          meta: {
            label: label.page.lading,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PPARAKLadingAdd",
          component: () =>
            import("@/views/modules/pparak/operation/lading/add.vue"),
          meta: {
            label: label.page.addLading,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PPARAKLadingEdit",
          component: () =>
            import("@/views/modules/pparak/operation/lading/add.vue"),
          meta: {
            label: label.page.editLading,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "reports",
      name: "PPARAKReports",
      meta: {
        label: label.page.reports,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "cottageReport",
          name: "PPARAKCottageReport",
          meta: {
            label: label.page.cottageReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pparak/reports/cottage/index.vue"),
        },
        {
          path: "purchaseReport",
          name: "PPARAKPurchaseReport",
          meta: {
            label: label.page.purchaseReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pparak/reports/purchase/index.vue"),
        },
        {
          path: "orderReport",
          name: "PPARAKOrderReport",
          meta: {
            label: label.page.orderReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pparak/reports/order/index.vue"),
        },
        {
          path: "comprehensiveOrder",
          name: "PPARAKComprehensiveOrderReport",
          meta: {
            label: label.page.comprehensiveOrder,
            requiresAuth: true,
          },
          component: () =>
            import(
              "@/views/modules/pparak/reports/comprehensiveOrder/index.vue"
            ),
        },
      ],
    },
  ],
};

export default routeItems;
